const ACTIVE_CLASS = 'fs-carousel__controls__button--active'

class FsCarousel extends HTMLElement {
  constructor() {
    super()
    this.elCarousel = this.querySelector('.fs-carousel')
    this.elControls = this.querySelector('.fs-carousel__controls')
    this.elsControlButtons = []
    this.itemsOnScreen = 0

    this.setControlsCount()
    this.addEventListeners()
    this.addResizeListener()
  }

  setControlsCount() {
    if (!this.elControls) {
      return
    }
    const elControlButton = this.elControls.querySelector('button').cloneNode(true)
    this.elsControlButtons = []

    this.elControls.innerHTML = ''

    const itemsCount = this.elCarousel.children.length
    this.itemsOnScreen = Math.round(this.elCarousel.offsetWidth / this.elCarousel.children[0].offsetWidth)
    const controlsCount = Math.ceil(itemsCount / this.itemsOnScreen)

    for (let i = 0; i < controlsCount; i++) {
      const button = elControlButton.cloneNode(true)
      const itemIndex = i * this.itemsOnScreen

      button.ariaLabel = `Go to page ${itemIndex + 1}`
      button.classList.remove(ACTIVE_CLASS)

      button.addEventListener('click', () => {
        Array.from(this.elControls.querySelectorAll('button')).forEach(button => button.classList.remove(ACTIVE_CLASS))
        button.classList.add(ACTIVE_CLASS)
        this.scrollToItem(itemIndex)
      })

      this.elControls.appendChild(button)
      this.elsControlButtons.push(button)
    }

    this.elsControlButtons[0].classList.add(ACTIVE_CLASS)
    this.elControls.classList.toggle('hidden', controlsCount === 1)
  }

  scrollToItem(index) {
    const item = this.elCarousel.children[index]
    this.elCarousel.scrollTo({
      left: item.offsetLeft,
      behavior: 'smooth',
    })
  }

  onScroll() {
    const firstItemOnScreen = Math.round(this.elCarousel.scrollLeft / this.elCarousel.children[0].offsetWidth)
    const isLastPage = firstItemOnScreen + this.itemsOnScreen >= this.elCarousel.children.length
    const activeControlIndex = isLastPage ? this.elsControlButtons.length - 1 : Math.round(firstItemOnScreen / this.itemsOnScreen)
    const activeControl = this.elsControlButtons[activeControlIndex]

    this.elsControlButtons.forEach(control => control.classList.remove(ACTIVE_CLASS))
    activeControl.classList.add(ACTIVE_CLASS)
  }

  addResizeListener() {
    const onResize = () => {
      this.setControlsCount()
    }

    window.addEventListener('resize', () => {
      clearTimeout(this.resizeTimeout)
      this.resizeTimeout = setTimeout(onResize, 100)
    })
  }

  addEventListeners() {
    if (!this.elControls) {
      return
    }

    this.elCarousel.addEventListener('scroll', () => {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = setTimeout(() => {
        this.onScroll()
      }, 100)
    })
  }
}

if (!customElements.get('fs-carousel')) {
  customElements.define('fs-carousel', FsCarousel)
}
